import { ModalHandler } from '@app-velocity/ui';

import { RunAnotherSimulationModalContent } from './components/RunAnotherSimulationModalContent';

export const RunAnotherSimulationModal = () => {
  return (
    <ModalHandler
      id="run-again"
      channel="prototypes"
    >
      <RunAnotherSimulationModalContent />
    </ModalHandler>
  );
};
